<script setup>
import { ref, onMounted } from 'vue'

import { getI18n } from '@/plugins/i18n'

import { usePlanningStore } from '@/stores/planning.store'

import { useIsUpdated } from '@/composables/object'

import FormSectionTitle from '@/components/shared/FormSectionTitle.vue'
import StaffPersonalFields from '@/components/shared/StaffPersonalFields.vue'

const props = defineProps({
  staffId: {
    type: Number,
    required: true,
  },
})

const i18n = getI18n()
const planningStore = usePlanningStore()

const PERSONAL_FIELDS = Object.freeze(['fiscal_code', 'birth_date', 'birth_place', 'street', 'street_number', 'zip_code', 'city', 'country', 'iban'])

const personal = ref({})
const { isUpdated, setOriginal } = useIsUpdated(personal)

const pickPersonal = (staff) => Object.fromEntries(PERSONAL_FIELDS.map(field => [field, staff[field] ?? null]))

const loadAsync = async() => {
  const staff = await planningStore.fetchStaffByIdAsync(props.staffId)
  personal.value = pickPersonal(staff.data)
  setOriginal(personal.value)
}

const saveAsync = async() => {
  const { data } = await planningStore.patchStaffAsync(props.staffId, personal.value)
  personal.value = pickPersonal(data)
  setOriginal(personal.value)
}

onMounted(loadAsync)

defineExpose({ isUpdated, saveAsync })
</script>

<template>
  <div class="row q-col-gutter-sm">
    <staff-personal-fields v-model="personal" />
    <form-section-title :label="i18n.t('common.payment')" />
    <q-input
      v-model="personal.iban"
      class="col-12"
      :label="i18n.t('common.iban')"
      maxlength="42"
    />
  </div>
</template>
